import React, { useContext, useEffect } from "react";
import { AppContext } from "../context/EditSessionsContext";
import { useGetLink } from "../hooks/useGetLinks";
import { useGetBlocks } from "../hooks/useGetBlocks";
import { useLoadBlockingThreshold } from "../hooks/useLoadBlockingThreshold";
import EditSessionSkeleton from "./edit-session-skeleton";
import InitEditSessions from "./InitEditSessions";
import { Types } from "../context/switchPage.reducer";
import { Types as TypeLink } from "../context/linkData.reducer";
import { Types as TypeResult } from "../context/result.reducer";
import { Types as TypeForm } from "../context/formData.reducer";

const EditSessionLayout: React.FC = () => {
  const { state, dispatch } = useContext(AppContext);
  const [dataLinks, getDataLinks] = useGetLink();
  const [dataBlocks, getDataBlocks] = useGetBlocks();
  const { loadBlockingThreshold } = useLoadBlockingThreshold();

  const handleCleanData = () => {
    dispatch({ type: Types.CleanSwitchPage });
    dispatch({ type: TypeLink.CleanLinkData });
    dispatch({ type: TypeResult.CleanResultData });
    dispatch({ type: TypeForm.CleanForm, payload: true });
  };

  const handleGetInitialData = () => {
    handleCleanData();
    getDataLinks(true);
    getDataBlocks(true);
  };

  useEffect(() => {
    if (dataLinks === null) getDataLinks();
    if (dataBlocks.dataEnd === null) getDataBlocks();
    loadBlockingThreshold();

    window.addEventListener("fetch-link-sessions-info", handleGetInitialData);

    return () => {
      window.removeEventListener("fetch-link-sessions-info", handleGetInitialData);
      handleCleanData();
    };
  }, []);

  if (!dataLinks || !dataBlocks || !state?.link?.info) {
    return <EditSessionSkeleton />;
  }

  return <InitEditSessions />;
};

export default EditSessionLayout;
